// Single source of truth for harness dropdowns (no components — kept out of
// AgentHarnessAutoInstall.tsx / McpSetupPage.tsx so those files only export
// components for react-refresh).
//
// Canonical order follows the backend setup tool
// (`SUPPORTED_AGENT_HARNESSES` in backend/api/mcp/agent-harness-setup.ts)
// with `claude-desktop` appended: it has an MCP config but no
// `setup_agent_harness` support, so it appears in MCP lists only.

export interface HarnessOption {
  value: string
  label: string
}

interface HarnessMeta extends HarnessOption {
  /**
   * Default skill-file location (mirrors the backend defaultSkillPath), or
   * null when the harness has no `setup_agent_harness` support and therefore
   * never appears in skill dropdowns.
   */
  skillPath: string | null
}

const HARNESS_META: HarnessMeta[] = [
  {
    value: 'claude-code',
    label: 'Claude Code',
    skillPath: '.claude/skills/context-harbor/SKILL.md',
  },
  { value: 'cursor', label: 'Cursor', skillPath: '.cursor/skills/context-harbor.md' },
  { value: 'opencode', label: 'OpenCode', skillPath: '.opencode/skills/context-harbor/SKILL.md' },
  { value: 'chatgpt', label: 'ChatGPT Work', skillPath: '.agents/skills/context-harbor/SKILL.md' },
  { value: 'codex', label: 'Codex', skillPath: '.codex/skills/context-harbor/SKILL.md' },
  { value: 'claude-desktop', label: 'Claude Desktop', skillPath: null },
  { value: 'generic', label: 'Other / generic', skillPath: '.cursor/skills/context-harbor.md' },
]

function toOption(harness: HarnessMeta): HarnessOption {
  return { value: harness.value, label: harness.label }
}

/** Harnesses the skill install flow supports (drives `setup_agent_harness`). */
export const SKILL_HARNESSES: HarnessOption[] = HARNESS_META.filter(
  (harness) => harness.skillPath !== null
).map(toOption)

/** Default skill-file location per harness. */
export const SKILL_HARNESS_PATHS: Record<string, string> = Object.fromEntries(
  HARNESS_META.filter((harness) => harness.skillPath !== null).map((harness) => [
    harness.value,
    harness.skillPath as string,
  ])
)

/** Every harness with an MCP client config (the MCP Setup dropdown). */
export const MCP_HARNESS_OPTIONS: HarnessOption[] = HARNESS_META.map(toOption)

/** What `setup_agent_harness` installs by default for a harness. */
export function harnessInstallSummary(harness: string): string {
  if (harness === 'claude-code') {
    return 'skill file + AGENTS.md + CLAUDE.md + memory-capture Stop hook'
  }
  return 'skill file + AGENTS.md'
}
